import { mapper } from '@maia/icons';
import { BillingUnitDto } from '@maia/shared';
import {
  BigPricingPill,
  cardStyles,
  SectionWithHeader,
  SpecList,
  Typography,
} from '@maia/ui';
import { formatCurrency } from '@maia/utils';
import { twMerge } from 'tailwind-merge';

type Item = {
  readonly label: string;
  readonly value: string;
  readonly oldValue?: string;
  readonly icon: string;
};

type FinalPriceSectionProps = {
  readonly items: Array<Item>;
  readonly totalPrice: number;
  readonly tax: number;
  readonly billingUnit: BillingUnitDto;
};

export function FinalPriceSection(props: FinalPriceSectionProps) {
  const { items, tax, totalPrice, billingUnit } = props;

  return (
    <SectionWithHeader title="Nieuwe premie" className="col-span-full">
      <div
        className={twMerge(
          cardStyles({ variant: 'outlined' }),
          'p-20 rounded-b-none border-b-0',
        )}
      >
        <SpecList
          items={items.map((item) => {
            return {
              title: (
                <span className="inline-flex items-center gap-x-12">
                  <span className="[&>svg]:size-24 [&>svg]:fill-primaryMain">
                    {mapper(item.icon)}
                  </span>
                  <Typography variant="body-m" weight="medium">
                    {item.label}
                  </Typography>
                </span>
              ),
              value: (
                <span className="inline-flex items-center gap-x-4">
                  {item.oldValue && (
                    <Typography
                      variant="body-s"
                      weight="regular"
                      className="line-through text-grayscale400"
                    >
                      {formatCurrency(item.oldValue)}
                    </Typography>
                  )}
                  <Typography variant="body-s" weight="semibold">
                    {formatCurrency(item.value)}
                  </Typography>
                  <Typography
                    variant="body-s"
                    weight="regular"
                    className="text-grayscale400"
                  >
                    {billingUnit.label}
                  </Typography>
                </span>
              ),
            };
          })}
        />
      </div>
      <div className="flex items-center justify-between bg-primary50 p-20 pt-32 border border-t-0 border-grayscale100 rounded-b-12 zigzag -mt-12">
        <div className="flex flex-col gap-y-8">
          <Typography variant="body-m" weight="medium">
            Je premie
          </Typography>
          {tax && (
            <Typography variant="body-xs" weight="regular">
              Incl. {formatCurrency(tax)} assurantiebelasting
            </Typography>
          )}
        </div>
        <BigPricingPill
          size="md"
          variant="ghost"
          price={totalPrice}
          billingUnit={billingUnit}
        />
      </div>
    </SectionWithHeader>
  );
}
